module.exports = __webpack_public_path__ + "img/chess-searchbg3.d5abba6c.jpg";